var _path, _path2, _path3, _path4, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetricCases(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9095_5386)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9095_5386",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9095_5386)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9095_5386",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 0H0V24H24V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9095_5386)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 0H4C1.79086 0 0 1.79086 0 4V20C0 22.2091 1.79086 24 4 24H20C22.2091 24 24 22.2091 24 20V4C24 1.79086 22.2091 0 20 0Z",
    fill: "url(#paint0_linear_9095_5386)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9095_5386",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 12,
    height: 12
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 6H6V18H18V6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9095_5386)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9095_5386)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.728 18H7.27151C6.99476 18 6.72935 17.8901 6.53366 17.6944C6.33796 17.4987 6.22803 17.2333 6.22803 16.9565V7.04348C6.22803 6.76673 6.33796 6.50132 6.53366 6.30563C6.72935 6.10994 6.99476 6 7.27151 6H16.728C17.0048 6 17.2702 6.10994 17.4659 6.30563C17.6616 6.50132 17.7715 6.76673 17.7715 7.04348V16.9565C17.7715 17.2333 17.6616 17.4987 17.4659 17.6944C17.2702 17.8901 17.0048 18 16.728 18ZM16.728 7.04348H7.27151V16.9565H16.728V7.04348ZM8.83672 8.6087C8.93991 8.6087 9.04079 8.6393 9.12659 8.69662C9.21239 8.75395 9.27926 8.83544 9.31875 8.93077C9.35824 9.02611 9.36857 9.13101 9.34844 9.23222C9.32831 9.33343 9.27862 9.42639 9.20565 9.49936C9.13268 9.57233 9.03972 9.62202 8.93851 9.64215C8.8373 9.66228 8.7324 9.65195 8.63706 9.61246C8.54173 9.57297 8.46024 9.5061 8.40291 9.4203C8.34558 9.3345 8.31498 9.23362 8.31498 9.13043C8.31498 9.06192 8.32848 8.99407 8.3547 8.93077C8.38092 8.86747 8.41935 8.80996 8.4678 8.76151C8.51625 8.71306 8.57376 8.67463 8.63706 8.64841C8.70036 8.62219 8.76821 8.6087 8.83672 8.6087ZM8.83672 11.2174C8.93991 11.2174 9.04079 11.248 9.12659 11.3053C9.21239 11.3626 9.27926 11.4441 9.31875 11.5395C9.35824 11.6348 9.36857 11.7397 9.34844 11.8409C9.32831 11.9421 9.27862 12.0351 9.20565 12.1081C9.13268 12.181 9.03972 12.2307 8.93851 12.2508C8.8373 12.271 8.7324 12.2606 8.63706 12.2212C8.54173 12.1817 8.46024 12.1148 8.40291 12.029C8.34558 11.9432 8.31498 11.8423 8.31498 11.7391C8.31498 11.6706 8.32848 11.6028 8.3547 11.5395C8.38092 11.4762 8.41935 11.4187 8.4678 11.3702C8.51625 11.3218 8.57376 11.2833 8.63706 11.2571C8.70036 11.2309 8.76821 11.2174 8.83672 11.2174ZM8.83672 13.8261C8.93991 13.8261 9.04079 13.8567 9.12659 13.914C9.21239 13.9713 9.27926 14.0528 9.31875 14.1482C9.35824 14.2435 9.36857 14.3484 9.34844 14.4496C9.32831 14.5508 9.27862 14.6438 9.20565 14.7168C9.13268 14.7897 9.03972 14.8394 8.93851 14.8595C8.8373 14.8797 8.7324 14.8693 8.63706 14.8298C8.54173 14.7904 8.46024 14.7235 8.40291 14.6377C8.34558 14.5519 8.31498 14.451 8.31498 14.3478C8.31498 14.2793 8.32848 14.2115 8.3547 14.1482C8.38092 14.0849 8.41935 14.0273 8.4678 13.9789C8.51625 13.9305 8.57376 13.892 8.63706 13.8658C8.70036 13.8396 8.76821 13.8261 8.83672 13.8261ZM10.9399 8.6087H15.1466C15.285 8.6087 15.4177 8.66366 15.5156 8.76151C15.6134 8.85935 15.6684 8.99206 15.6684 9.13043C15.6684 9.26881 15.6134 9.40152 15.5156 9.49936C15.4177 9.59721 15.285 9.65217 15.1466 9.65217H10.9399C10.8015 9.65217 10.6688 9.59721 10.5709 9.49936C10.4731 9.40152 10.4181 9.26881 10.4181 9.13043C10.4181 8.99206 10.4731 8.85935 10.5709 8.76151C10.6688 8.66366 10.8015 8.6087 10.9399 8.6087ZM10.9399 11.2174H15.1466C15.285 11.2174 15.4177 11.2724 15.5156 11.3702C15.6134 11.4681 15.6684 11.6008 15.6684 11.7391C15.6684 11.8775 15.6134 12.0102 15.5156 12.1081C15.4177 12.2059 15.285 12.2609 15.1466 12.2609H10.9399C10.8015 12.2609 10.6688 12.2059 10.5709 12.1081C10.4731 12.0102 10.4181 11.8775 10.4181 11.7391C10.4181 11.6008 10.4731 11.4681 10.5709 11.3702C10.6688 11.2724 10.8015 11.2174 10.9399 11.2174ZM10.9399 13.8261H15.1299C15.2683 13.8261 15.401 13.8811 15.4989 13.9789C15.5967 14.0767 15.6517 14.2095 15.6517 14.3478C15.6517 14.4862 15.5967 14.6189 15.4989 14.7168C15.401 14.8146 15.2683 14.8696 15.1299 14.8696H10.9399C10.8015 14.8696 10.6688 14.8146 10.5709 14.7168C10.4731 14.6189 10.4181 14.4862 10.4181 14.3478C10.4181 14.2095 10.4731 14.0767 10.5709 13.9789C10.6688 13.8811 10.8015 13.8261 10.9399 13.8261Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9095_5386",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9095_5386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9095_5386"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricCases);
export default __webpack_public_path__ + "static/media/Metric-Cases.22f4d00cc40829f058b2f1ce67d3f604.svg";
export { ForwardRef as ReactComponent };